import { render } from "./roles-list.html?vue&type=template&id=e1c7de10&scoped=true&ts=true"
import script from "./roles-list.ts?vue&type=script&lang=ts"
export * from "./roles-list.ts?vue&type=script&lang=ts"

import "./roles-list.scss?vue&type=style&index=0&id=e1c7de10&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c7de10"]])

export default __exports__